const ITEMS = [
  'GEORGIA TECH ENGINEERING',
  'CUSTOM WEB ARCHITECTURES',
  'AUTOMATED LEAD PIPELINES',
  'CLOUDFLARE & AWS EDGE',
  'STRIPE · PAYPAL · ZELLE READY',
  'PRIVATE OWNER PORTALS',
  '100% CUSTOM CODE',
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-amber-500/15 bg-[#0B1528]/60 py-5 overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono-tech text-xs tracking-[0.35em] text-slate-400 uppercase">
            <span className="px-8">{item}</span>
            <span className="text-amber-500/70">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
